
















import {checkArgs, executeFunction, Shortcut} from "@/edinet/libs/shortcuts"
import Vue, {PropType} from 'vue'
import CollapsibleGroup from '@/edinet/components/CollapsibleGroup.vue'

interface RenderingShortcut extends Shortcut {
  cls: string
}

const instance = Vue.extend({
  components: {CollapsibleGroup},
  props: {
    sections: {
      type: Array as PropType<Array<string>>
    },
    shortcutDef: {
      type: Array as PropType<Array<Shortcut>>
    }
  },
  data() {
    return {
      shortcuts: [] as RenderingShortcut[]
    }
  },
  mounted() {
    this.update()
  },
  methods: {
    //IMPORTANT: manually call from parent after doc html render
    update: function() {
      this.shortcuts.length = 0
      for (const s of this.shortcutDef) {
        const isValid = checkArgs(s)
        this.shortcuts.push({...s, cls: isValid ? 'valid' : 'invalid'})
      }
    },
    sectionShortcuts(section: string) {
      return this.shortcuts.filter(x => x.section === section)
    },
    executeShortcut: function(section: string, shortLabel: string) {
      const shortcut = this.shortcuts.find(x => x.section === section && x.shortLabel === shortLabel)
      if (shortcut) {
        executeFunction(shortcut)
      } else {
        console.warn(`shortcut with shortLabel '${shortLabel}' not found in '${section}' shortcuts %o`, this.shortcuts)
      }
    }
  }
})

export default instance
